import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Container, Typography, Stack, Button } from '@mui/material'; // Button をインポート
import { Helmet } from 'react-helmet';
import { getRegisterFormData } from '../common_modules/components/Common';
import RegisterLayout from '../common_modules/components/RegisterLayout';
import RegisterHeaderProgress from '../common_modules/components/RegisterHeaderProgress';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import { useNavigate } from 'react-router-dom'; // useNavigate をインポート

interface RegisterFormData {
  email?: string;
  mobilePhone?: string;
}

const FinishRegistration: React.FC = () => {
  const translate = useTranslate();
  const navigate = useNavigate(); // useNavigateフックを使用

  const [tel, setTel] = useState<string | undefined>('');
  const [email, setEmail] = useState<string | undefined>('');

  useEffect(() => {
    const formData = getRegisterFormData() as RegisterFormData;
    if (formData) {
      setEmail(formData.email);
      setTel(formData.mobilePhone);
    } else {
      // フォームデータがない場合、何らかの理由でこのページに直接到達したか、
      // セッションが切れた可能性があるので、適切な初期ページにリダイレクトすることも検討
      // 例: navigate('/register/client/form', { replace: true });
      console.warn('FinishRegistration: Form data not found in sessionStorage.');
    }
  }, []); // このuseEffectはマウント時に一度だけ実行

  useEffect(() => {
    // 現在のURLで履歴スタックに新しいエントリを追加する
    // これにより、ユーザーが「戻る」を押すと、まずこの追加された「現在の状態」に戻ろうとする
    window.history.pushState(null, '', window.location.href);

    const blockBackButton = (event: PopStateEvent) => {
      // popstateイベントが発生したら（戻る/進むボタンが押されたら）
      // 再度現在のURLで履歴エントリを追加し直す
      // これにより、実質的に同じページに留まるように見せる
      window.history.pushState(null, '', window.location.href);
      console.log('Back button pressed on FinishRegistration page - blocked.');
    };

    // popstateイベントリスナーを追加
    window.addEventListener('popstate', blockBackButton);

    // コンポーネントがアンマウントされる際にイベントリスナーをクリーンアップ
    return () => {
      window.removeEventListener('popstate', blockBackButton);
      // アンマウント時（ユーザーが別のリンクをクリックするなどしてこのページを離れる時）に
      // この制御は自動的に解除されます。
      // もし特別なクリーンアップ（例: サーバーに通知など）が必要な場合はここで行いますが、
      // 通常、履歴操作のクリーンアップは不要です。
    };
  }, []); // このuseEffectもマウント時に一度だけ実行

  return (
    <RegisterLayout>
      <Container
        sx={{
          maxWidth: { sm: '552px', md: '772px' },
          marginTop: { xs: '20px', sm: '40px' },
          // marginBottom: { xs: '20px', sm: '40px'},
          marginBottom: '40px',
          borderRadius: { sm: '24px', md: '24px' },
          border: { sm: '1px solid #EEEEEE', md: '1px solid #EEEEEE' },
          backgroundColor: '#FFFFFF'
        }}
      >
        <Helmet>
          <title>{translate('resources.registers.name.Identification')}</title>
        </Helmet>
        <Stack
          spacing={1}
          gap={4}
          sx={{
            paddingLeft: { xs: '16px', sm: '40px', md: '64px' },
            paddingRight: { xs: '16px', sm: '40px', md: '64px' },
            paddingTop: { sm: '40px', md: '64px' },
            paddingBottom: { sm: '40px', md: '64px' }
          }}
        >
          <RegisterHeaderProgress
            title={translate('resources.registers.name.Identification')}
            icon={<HowToRegOutlinedIcon />}
            step={6}
            totalSteps={6}
          />

          <Box display="flex" justifyContent="center">
            <Box
              sx={{
                width: { xs: '288px', sm: '400px' },
                height: '20px'
              }}
              component="img"
              src={`/images/stepper/img_stepper_6.svg`}
              alt="stepper_6"
            />
          </Box>

          <Typography
            sx={{
              marginTop: '24px'
            }}
          >
            {/* ECサイト登録の申請ありがとうございます。 */}
            ご登録のメールアドレス({email})へ本人確認のメールが送信されましたので、ご確認をお願いいたします。
            <br />
            <span>
              {/* ご登録のメールアドレス({email})へ本人確認のメールが送信されましたので、ご確認をお願いいたします。 */}
              本人確認が完了したら、ECサイト登録のための審査が開始されます。
            </span>
          </Typography>
        </Stack>
      </Container>
    </RegisterLayout>
  );
};

export default FinishRegistration;
